import React, { useState, useEffect, useMemo } from "react";
import { useParams, useHistory } from "react-router-dom";
import "./index.scss";
import {
  courseDataMap,
  courseTitleMap,
  totalDurationMap,
} from "./optionsVideoMetadata";
import VideoPage from "./VideoPage";
import taLogoDark from "./assets/ta-logo-dark.png";
import taLogoWhite from "./assets/ta-logo-white.png";
import { connect } from "react-redux";
import OptionsAcademyChat from "../Chat/OptionsAcademyChat";
import VideoCardsContainer from "./VideoCardsContainer";
import OptionsAcademyLivestream from "./OptionsAcademyLivestream";
const OptionsAcademy = ({ themeMode }) => {
  const { main, sub } = useParams();
  const [currentNav, setCurrentNav] = useState(main);
  const [courseTab, setCourseTab] = useState(sub || "fundamentals");
  const [currentVideo, setCurrentVideo] = useState({});
  const hardHistory = useHistory();

  useEffect(() => {
    if (main) {
      if (currentNav === "courses") {
        hardHistory.push(`/options-academy/${currentNav}/${courseTab}`);
      } else {
        hardHistory.push(`/options-academy/${currentNav}`);
      }
    }
  }, [currentNav, courseTab]);
  const navigateTabs = (tab) => {
    setCurrentVideo({});
    setCurrentNav(tab);
  };
  const allVideos = useMemo(() => {
    return courseDataMap[courseTab];
  }, [courseTab]);

  return (
    <div>
      <div>
        <div>
          <div className="pl-20 platinum-program-page-navigator mw-800">
            {/* <div
              className={`platinum-program-page-navItem ${currentNav === "real-time-alerts" ? "active" : ""}`}
              onClick={() => navigateTabs("real-time-alerts")}
            >
              Real-time Alerts
            </div> */}
            <div
              className={`platinum-program-page-navItem ${currentNav === "courses" ? "active" : ""}`}
              onClick={() => navigateTabs("courses")}
            >
              Options Academy
            </div>
            <div
              className={`platinum-program-page-navItem ${currentNav === "livestream" ? "active" : ""}`}
              onClick={() => navigateTabs("livestream")}
            >
              Livestream
            </div>
            <div
              className={`platinum-program-page-navItem ${currentNav === "support" ? "active" : ""}`}
              onClick={() => navigateTabs("support")}
            >
              Support
            </div>
          </div>
          <div className="flex-col pl-20">
            {currentNav !== "real-time-alerts" && (
              <div className="logo-title-wrap">
                <img
                  className="ta-logo-oa"
                  src={themeMode === "dark" ? taLogoWhite : taLogoDark}
                />
                <div className="new-title">Options Academy</div>
              </div>
            )}
          </div>
          {currentNav === "courses" && (
            <div className="pl-20 courses-wrapper">
              {!currentVideo?.videoUrl ? (
                <>
                  <div className="oa-inner-subtitle">
                    Welcome to Trade Algo Options Academy! Our structured
                    video-based curriculum simplifies the complexities of
                    options trading so you can reinforce your learning anytime.
                  </div>
                  <div className=" mw-930 pt-40 platinum-program-page-navigator">
                    <div
                      className={`platinum-program-page-navItem ${courseTab === "fundamentals" ? "active" : ""}`}
                      onClick={() => setCourseTab("fundamentals")}
                    >
                      Fundamentals
                    </div>
                    <div
                      className={`platinum-program-page-navItem ${courseTab === "intermediate" ? "active" : ""}`}
                      onClick={() => setCourseTab("intermediate")}
                    >
                      Intermediate
                    </div>
                    <div
                      className={`platinum-program-page-navItem ${courseTab === "leaps" ? "active" : ""}`}
                      onClick={() => setCourseTab("leaps")}
                    >
                      L.E.A.P.S
                    </div>
                    <div
                      className={`platinum-program-page-navItem ${courseTab === "cash-secured-puts" ? "active" : ""}`}
                      onClick={() => setCourseTab("cash-secured-puts")}
                    >
                      Cash Secured Puts
                    </div>
                    <div
                      className={`platinum-program-page-navItem ${courseTab === "advanced" ? "active" : ""}`}
                      onClick={() => setCourseTab("advanced")}
                    >
                      Advanced
                    </div>
                  </div>
                  <div className="courses-title-wrapper">
                    <span className="course-title">
                      {courseTitleMap[courseTab]}
                    </span>
                    <span className="course-subtitle">
                      {totalDurationMap[courseTab].totalVideos} lessons •{" "}
                      {totalDurationMap[courseTab].duration}
                    </span>
                  </div>
                  <VideoCardsContainer
                    courses={courseDataMap[courseTab]}
                    setCurrentVideo={setCurrentVideo}
                    type={courseTab}
                    courseName={courseTitleMap[courseTab]}
                  />
                </>
              ) : (
                <VideoPage
                  allVideos={allVideos}
                  currentVideo={currentVideo}
                  setCurrentVideo={setCurrentVideo}
                  courseTab={courseTab}
                  setCourseTab={setCourseTab}
                />
              )}
            </div>
          )}

          {(currentNav === "livestream" || currentNav === "support") && (
            <OptionsAcademyLivestream isSupport={currentNav === "support"} />
          )}
          {/* {currentNav === "real-time-alerts" && (
            <>
              <OptionsAcademyChat />
            </>
          )} */}
        </div>
      </div>
    </div>
  );
};

const stateToProps = (state) => ({
  themeMode: state.themeMode.themeMode,
});

export default connect(stateToProps, null)(OptionsAcademy);
